import { createFileRoute, Outlet, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";

export const Route = createFileRoute("/_app/_admin")({ component: AdminGuard });

function AdminGuard() {
  const { role, loading } = useAuth();
  if (loading) return null;
  if (role !== "admin" && role !== "moderator") return <Navigate to="/dashboard" />;
  return <Outlet />;
}
